// extracted by mini-css-extract-plugin
export default {"wrapper":"HistoryMissing_wrapper__2oEJi","icon":"HistoryMissing_icon__JCGvX","btn":"HistoryMissing_btn__XCxk-"};